(function () {
  const MODE_CLASS = "accessibility-mode";
  const PANEL_ID = "accessibility-panel";
  const FONT_STORAGE_KEY = "bionlab:accessibility-font-size";
  const TOGGLE_PATH = "/accessibility";

  const MIN_FONT_SIZE = 18;
  const DEFAULT_FONT_SIZE = 20;
  const MAX_FONT_SIZE = 32;
  const FONT_SIZE_STEP = 2;

  const ENABLE_LABEL = "Включить версию для слабовидящих";
  const DISABLE_LABEL = "Выключить версию для слабовидящих";

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
    } else {
      callback();
    }
  }

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // localStorage can be disabled; the current page still keeps working.
    }
  }

  function clampFontSize(value) {
    const parsedValue = Number.parseInt(value, 10);
    if (!Number.isFinite(parsedValue)) return DEFAULT_FONT_SIZE;

    const clampedValue = Math.min(
      Math.max(parsedValue, MIN_FONT_SIZE),
      MAX_FONT_SIZE
    );
    const steps = Math.round((clampedValue - MIN_FONT_SIZE) / FONT_SIZE_STEP);
    return MIN_FONT_SIZE + steps * FONT_SIZE_STEP;
  }

  function getStoredFontSize() {
    return clampFontSize(storageGet(FONT_STORAGE_KEY));
  }

  function isModeEnabled() {
    return document.body && document.body.classList.contains(MODE_CLASS);
  }

  function setToggleButtonAttributes(button, enabled) {
    const label = enabled ? DISABLE_LABEL : ENABLE_LABEL;
    button.setAttribute("aria-label", label);
    button.setAttribute("title", label);
    button.setAttribute("href", TOGGLE_PATH);
  }

  function updateToggleButtons() {
    const enabled = isModeEnabled();
    document.querySelectorAll(".accessibility").forEach(function (button) {
      setToggleButtonAttributes(button, enabled);
    });
  }

  function closestElement(target, selector) {
    if (!target) return null;
    const element =
      target.nodeType === Node.ELEMENT_NODE ? target : target.parentElement;
    return element ? element.closest(selector) : null;
  }

  function updateFontButtonStates(size) {
    const panel = document.getElementById(PANEL_ID);
    if (!panel) return;

    const decreaseButton = panel.querySelector(
      '[data-accessibility-action="font-decrease"]'
    );
    const increaseButton = panel.querySelector(
      '[data-accessibility-action="font-increase"]'
    );

    if (decreaseButton) {
      decreaseButton.disabled = size <= MIN_FONT_SIZE;
      decreaseButton.setAttribute(
        "aria-disabled",
        size <= MIN_FONT_SIZE ? "true" : "false"
      );
    }

    if (increaseButton) {
      increaseButton.disabled = size >= MAX_FONT_SIZE;
      increaseButton.setAttribute(
        "aria-disabled",
        size >= MAX_FONT_SIZE ? "true" : "false"
      );
    }
  }

  function setFontSize(size, persist) {
    if (!document.body) return;

    const normalizedSize = clampFontSize(size);
    document.body.style.setProperty(
      "--accessibility-font-size",
      normalizedSize + "px"
    );
    document.body.dataset.accessibilityFontSize = String(normalizedSize);

    if (persist) {
      storageSet(FONT_STORAGE_KEY, String(normalizedSize));
    }

    updateFontButtonStates(normalizedSize);
  }

  function pauseAutoplayDecor(enabled) {
    const videos = document.querySelectorAll("video[autoplay], .index-primary video");

    videos.forEach(function (video) {
      if (enabled) {
        if (!video.paused) {
          video.dataset.accessibilityPaused = "true";
        }
        try {
          video.pause();
        } catch (error) {
          // ignore media API failures
        }
      } else if (video.dataset.accessibilityPaused === "true") {
        delete video.dataset.accessibilityPaused;

        if (video.hasAttribute("autoplay")) {
          try {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === "function") {
              playPromise.catch(function () {});
            }
          } catch (error) {
            // ignore autoplay restrictions
          }
        }
      }
    });
  }

  function ensurePanel() {
    if (!document.body) return null;

    let panel = document.getElementById(PANEL_ID);
    if (panel) return panel;

    panel = document.createElement("div");
    panel.id = PANEL_ID;
    panel.className = "accessibility-panel";
    panel.setAttribute("role", "region");
    panel.setAttribute("aria-label", "Настройки версии для слабовидящих");
    panel.hidden = true;

    panel.innerHTML = [
      '<div class="accessibility-panel__inner">',
      '<span class="accessibility-panel__label">Размер текста</span>',
      '<button type="button" class="accessibility-panel__button" data-accessibility-action="font-decrease" aria-label="Уменьшить размер текста">A−</button>',
      '<button type="button" class="accessibility-panel__button" data-accessibility-action="font-increase" aria-label="Увеличить размер текста">A+</button>',
      '<button type="button" class="accessibility-panel__button" data-accessibility-action="font-reset">Сброс</button>',
      '<a href="' + TOGGLE_PATH + '" class="accessibility-panel__button accessibility-panel__button--version" data-accessibility-action="mode-disable">Обычная версия</a>',
      "</div>",
    ].join("");

    document.body.appendChild(panel);
    return panel;
  }

  function updatePanel() {
    const panel = ensurePanel();
    if (!panel) return;

    const enabled = isModeEnabled();
    panel.hidden = !enabled;
    panel.setAttribute("aria-hidden", enabled ? "false" : "true");
    updateFontButtonStates(
      clampFontSize(document.body && document.body.dataset.accessibilityFontSize)
    );
  }

  function setMode(enabled) {
    if (!document.body) return;

    document.documentElement.classList.toggle(MODE_CLASS, enabled);
    document.body.classList.toggle(MODE_CLASS, enabled);

    setFontSize(getStoredFontSize(), false);
    updateToggleButtons();
    updatePanel();
    pauseAutoplayDecor(enabled);
  }

  function changeFontSize(direction) {
    const currentSize = clampFontSize(
      document.body && document.body.dataset.accessibilityFontSize
    );
    setFontSize(currentSize + direction * FONT_SIZE_STEP, true);
  }

  function handleDocumentClick(event) {
    const actionButton = closestElement(
      event.target,
      "[data-accessibility-action]"
    );
    if (!actionButton) return;

    const action = actionButton.getAttribute("data-accessibility-action");

    if (action === "mode-disable") {
      return;
    }

    event.preventDefault();

    if (action === "font-decrease") {
      changeFontSize(-1);
    } else if (action === "font-increase") {
      changeFontSize(1);
    } else if (action === "font-reset") {
      setFontSize(DEFAULT_FONT_SIZE, true);
    }
  }

  function initAccessibilityMode() {
    if (!document.body) return;

    ensurePanel();
    setMode(isModeEnabled());
  }

  document.addEventListener("click", handleDocumentClick);

  ready(initAccessibilityMode);
  document.addEventListener("turbo:load", initAccessibilityMode);
  document.addEventListener("turbolinks:load", initAccessibilityMode);
})();
